import { Dispatch, useRef } from "react"
import OTPInput from "react-otp-input"

const OTP_LENGTH = 6

export const AppOTPInput = ({
  otp,
  setOtp,
  onComplete,
  disabled = false,
}: {
  otp: string
  setOtp: Dispatch<string>
  /**
   * Called once when the last digit goes in, with the full code. Typing the sixth digit is
   * the person saying "that's the code", so a separate Verify click is one step too many.
   * Fires again only after the code has been edited and completed anew, so a failed attempt
   * can be corrected and resubmitted without submitting the same code twice.
   */
  onComplete?: (code: string) => void
  /** Locks the boxes while the code is being checked. */
  disabled?: boolean
}) => {
  const lastSubmitted = useRef<string | null>(null)

  const handleChange = (value: string) => {
    setOtp(value)

    if (value.length < OTP_LENGTH) {
      lastSubmitted.current = null
      return
    }

    if (onComplete && value !== lastSubmitted.current) {
      lastSubmitted.current = value
      onComplete(value)
    }
  }

  return (
    <OTPInput
      containerStyle={{
        height: "2.5rem",
      }}
      value={otp}
      onChange={handleChange}
      renderInput={(props) => (
        <input
          {...props}
          disabled={disabled}
          className="!border !select-none !font-avenir !border-[#5D6B82] !w-[2.5rem] !h-full mx-2 !focus:border-inherit !hover:border-inherit !rounded-[4px] disabled:!bg-neutral20 disabled:!cursor-wait"
        />
      )}
      numInputs={OTP_LENGTH}
      shouldAutoFocus
      inputType="number"
    />
  )
}
